export default __webpack_public_path__ + "static/image-section-burger-dca1f79b0605670bbc6e4054eaf8fc7b.webp";